export default "__VITE_ASSET__u8N1M7DI__"